import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/pro-solid-svg-icons";

import styles from "./nextLinkCard.module.scss";
import { TextTruncate } from "components";
import { Tooltip } from "components/common/tooltip";

interface NextLinkCardProps {
  url: string;
  displayName: string;
  isReadOnly: boolean;
  onChange: () => void;
}

const NextLinkCard: React.FC<NextLinkCardProps> = ({ url, displayName, isReadOnly, onChange }) => {
  return (
    <div className={styles.root}>
      <div className={styles.stack}>
        <Tooltip
          className={styles.displayName}
          target={
            <TextTruncate className={styles.displayName} lines={1}>
              {displayName}
            </TextTruncate>
          }
          content={displayName}
        />
        <Tooltip className={styles.url} target={<TextTruncate lines={1}>{url}</TextTruncate>} content={url} />
      </div>
      {!isReadOnly && (
        <div className={styles["edit-icon"]} onClick={onChange} data-testid="edit-icon">
          <FontAwesomeIcon icon={faPencil} />
        </div>
      )}
    </div>
  );
};

export default NextLinkCard;
